import React, { Component } from 'react';
import './cate-report-loader.css';

class CateReportLoader extends Component {

    render() {
        return (
            <div>
                <div class="report_card ">
                    <article class="report_bg">
                        <div class="clearfix">
                            <a className="a_css">
                                <div className="img_css pull-right"></div>
                            </a>
                            <span className="span_loader">Published: February 2018</span>
                            <a className="a_css">
                                <h3 className="h3_css"></h3>
                            </a>
                            <div className="download_btn">
                            </div>

                            <br/>
                        </div>
                    </article>
                </div>

                <div class="report_card ">
                    <article class="report_bg">
                        <div class="clearfix">
                            <a className="a_css">
                                <div className="img_css pull-right"></div>
                            </a>
                            <span className="span_loader">Published: February 2018</span>
                            <a className="a_css">
                                <h3 className="h3_css"></h3>
                            </a>
                            <div className="download_btn">
                            </div>

                            <br/>
                        </div>
                    </article>
                </div>


                <div class="report_card ">
                    <article class="report_bg">
                        <div class="clearfix">
                            <a className="a_css">
                                <div className="img_css pull-right"></div>
                            </a>
                            <span className="span_loader">Published: February 2018</span>
                            <a className="a_css">
                                <h3 className="h3_css"></h3>
                            </a>
                            <div className="download_btn">
                            </div>

                            <br/>
                        </div>
                    </article>
                </div>


                <div class="report_card ">
                    <article class="report_bg">
                        <div class="clearfix">
                            <a className="a_css">
                                <div className="img_css pull-right"></div>
                            </a>
                            <span className="span_loader">Published: February 2018</span>
                            <a className="a_css">
                                <h3 className="h3_css"></h3>
                            </a>
                            <div className="download_btn">
                            </div>

                            <br/>
                        </div>
                    </article>
                </div>
            </div>
        );
    }


}


export default CateReportLoader;


// WEBPACK FOOTER //
// ./src/industry-reports/content/cate-reports/cate-report-loader.js